// extracted by mini-css-extract-plugin
export default {"item":"SettingsOptions__item___LktVg","link":"SettingsOptions__link___F3Ylh","activeLink":"SettingsOptions__activeLink___vrs0p","divider":"SettingsOptions__divider___jp0tE"};